import React from 'react'
import PropTypes from 'prop-types'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {Box, SimpleGrid, Text, VStack} from '@chakra-ui/react'
import useOcapiSite from '../../../hooks/useOcapiSite'
import ReactPlayerLoader from '@brightcove/react-player-loader'
import {useIntl} from 'react-intl'

const CustomerServiceHowToPage = ({products}) => {
    const pageConfig = useCustomerServicePageConfig()
    const {name, description} = pageConfig
    const intl = useIntl()

    const {accountId, assemblyVideoPlayerId, brightcoveEnabled} = useOcapiSite()

    return (
        <CustomerServiceLayoutDefault maxWidth="100%" pb={10}>
            <CSHeader headline={name} subline={description} />
            <VStack mt={8} spacing={8}>
                {products.map((product, index) => (
                    <VStack key={index} spacing={8} align="center">
                        <Text as="h2" textStyle={'Regular 2XLarge'} textAlign="center">
                            {product.name}
                        </Text>
                        {brightcoveEnabled && (
                            <SimpleGrid
                                columns={{base: 1, md: 2}}
                                rowGap={4}
                                columnGap={{base: 5, md: 4}}
                            >
                                {product.videos.map((video, index) => (
                                    <VStack key={index} spacing={4} w="100%" align="center">
                                        <Box
                                            border={'1px solid black'}
                                            w={{base: '21.5rem', md: '22rem', lg: '22.5rem'}}
                                        >
                                            <ReactPlayerLoader
                                                options={{
                                                    autoplay: false
                                                }}
                                                embedOptions={{
                                                    responsive: true
                                                }}
                                                accountId={accountId}
                                                playerId={assemblyVideoPlayerId}
                                                videoId={video.video}
                                                onSuccess={(success) => {
                                                    const {bigPlayButton: playButton} = success.ref
                                                    if (playButton) {
                                                        playButton.setAttribute(
                                                            'aria-label',
                                                            intl.formatMessage(
                                                                {
                                                                    defaultMessage:
                                                                        'Play video: {videoName}',
                                                                    id: 'customer_service.howto.play_video'
                                                                },
                                                                {videoName: video.name}
                                                            )
                                                        )
                                                    }
                                                }}
                                            />
                                        </Box>
                                        <Text
                                            textAlign="center"
                                            w={{base: '21.5rem', md: '22rem', lg: '22.5rem'}}
                                        >
                                            {video.name}
                                        </Text>
                                    </VStack>
                                ))}
                            </SimpleGrid>
                        )}
                    </VStack>
                ))}
            </VStack>
        </CustomerServiceLayoutDefault>
    )
}

CustomerServiceHowToPage.propTypes = {
    products: PropTypes.array
}

export default CustomerServiceHowToPage
